module.exports = __webpack_public_path__ + "img/zhangdan.b687b788.png";